import * as React from "react";
import cn from "classnames";
import Styles from "./ProfileLinks.module.scss";
import { buildProfileSearchUrls, nameForSearch, ProfileSearchContext } from "src/utils/player-profile-links";

type Variant = "badge" | "button";

export interface ProfileLinksProps extends ProfileSearchContext {
  /** `badge` = tiny PG/PBR icons for dense tables; `button` = labeled icons for the profile header. */
  variant?: Variant;
  className?: string;
}

// Served from /public; CRA rewrites PUBLIC_URL for the deploy path.
const PG_ICON = `${process.env.PUBLIC_URL}/pg-favicon.png`;
const PBR_ICON = `${process.env.PUBLIC_URL}/pbr-favicon.png`;

// In an AG-Grid cell these links sit inside a clickable/sortable row, so keep the click local.
const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();

export const ProfileLinks: React.FC<ProfileLinksProps> = ({ variant = "badge", className, ...ctx }) => {
  const { perfectGame, pbr } = buildProfileSearchUrls(ctx);
  const displayName = nameForSearch(ctx.name);

  return (
    <span className={cn(Styles.profileLinks, Styles[variant], className)}>
      <a
        href={perfectGame}
        target="_blank"
        rel="noopener noreferrer"
        className={Styles.link}
        title={`Search Perfect Game for ${displayName}`}
        aria-label={`Search Perfect Game for ${displayName}`}
        onClick={stopPropagation}
      >
        <img src={PG_ICON} alt="" aria-hidden="true" className={Styles.icon} />
        {variant === "button" && <span className={Styles.label}>Perfect Game</span>}
      </a>
      <a
        href={pbr}
        target="_blank"
        rel="noopener noreferrer"
        className={Styles.link}
        title={`Search Prep Baseball Report for ${displayName}`}
        aria-label={`Search Prep Baseball Report for ${displayName}`}
        onClick={stopPropagation}
      >
        <img src={PBR_ICON} alt="" aria-hidden="true" className={Styles.icon} />
        {variant === "button" && <span className={Styles.label}>PBR</span>}
      </a>
    </span>
  );
};
